import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService implements OnDestroy {
  isMobileSubject: BehaviorSubject<boolean>;
  isSmallMobileSubject: BehaviorSubject<boolean>;
  isMobile$: Observable<boolean>;
  isSmallMobile$: Observable<boolean>;

  private readonly smallMobileBreakpoint = 500; // actual mobile phones
  private readonly mobileBreakpoint = 1200; // Tablet mode breakpoint

  constructor() {
    // Initialize with the current screen size
    const initialIsMobile = window.innerWidth <= this.mobileBreakpoint;
    const initialIsSmallMobile = window.innerWidth <= this.smallMobileBreakpoint;

    this.isMobileSubject = new BehaviorSubject<boolean>(initialIsMobile);
    this.isMobile$ = this.isMobileSubject.asObservable();
    this.isSmallMobileSubject = new BehaviorSubject<boolean>(initialIsSmallMobile);
    this.isSmallMobile$ = this.isSmallMobileSubject.asObservable();

    // Listen to window resize events and emit screen size updates
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200), // Debounce to limit frequent events
        map(() => window.innerWidth <= this.mobileBreakpoint),
        startWith(initialIsMobile) // Start with the initial value
      )
      .subscribe((isMobile) => this.isMobileSubject.next(isMobile));

    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200), // Debounce to limit frequent events
        map(() => window.innerWidth <= this.smallMobileBreakpoint),
        startWith(initialIsSmallMobile) // Start with the initial value
      )
      .subscribe((isSmallMobile) => this.isSmallMobileSubject.next(isSmallMobile));
  }

  ngOnDestroy(): void {
    // Clean up the BehaviorSubject when service is destroyed
    this.isMobileSubject.complete();
    this.isSmallMobileSubject.complete();
  }
}
